import { type JobPostingBudgetInterval } from '#app/__generated__/api.js';

export const getBudgetAbbreviation = (interval: JobPostingBudgetInterval) => {
  switch (interval) {
    case 'DAY':
      return 'd';
    case 'HOUR':
      return 'hr';
    case 'MONTH':
      return 'mth';
    case 'WEEK':
      return 'wk';
    case 'YEAR':
      return 'yr';
    default:
      throw new Error(
        'An unsupported budget interval could not be abbreviated.',
      );
  }
};
